import axios from 'axios';

const API_URL = '/api/medications';

export const getMedications = async (user_id) => {
    if (!user_id) throw new Error("User ID is required");
    const res = await axios.get(API_URL, {
        params: { user_id }
    });

    return res.data;
}

export const getMedicationById = async (id) => {
    const res = await axios.get(`${API_URL}/${id}`);
    return res.data;
}

export const createMedication = async (medicationData) => {
    const res = await axios.post(API_URL, medicationData);
    return res.data;
}

export const updateMedication = async (id, medicationData) => {
    const res = await axios.put(`${API_URL}/${id}`, medicationData);
    return res.data;
}

export const deleteMedication = async (id) => {
    const res = await axios.delete(`${API_URL}/${id}`);
    return res.data;
}

export const getTodayMedications = async (user_id) => {
    const res = await axios.get(`${API_URL}/calendar/today/${user_id}`);
    return res.data;
}